"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Status = void 0;
/**
 * @interface Variant
 * @description A model to encapsulate data fetching operation. A variant have a status,
 *              possibly the data that was fetch, or an error if the fetching operation
 *              failed.
 */
var Status;
(function (Status) {
    Status["Unknown"] = "Unknown";
    Status["Success"] = "Success";
    Status["Error"] = "Error";
    Status["Pending"] = "Pending";
    Status["Refreshing"] = "Refreshing";
    Status["Polling"] = "Polling";
})(Status = exports.Status || (exports.Status = {}));
//# sourceMappingURL=variant.js.map